export const getters = {
    get_token: (state) => {
        return state.token || localStorage.getItem('token') || '';
    },

    get_hasToken: (state, getters) => {
        const token = getters.get_token;

        return token.length > 0;
    },

    get_voicemodAccountId: (state) => {
        return state.voicemodAccountId || localStorage.getItem('voicemodAccountId');
    },

    get_vmBitsConnectionButtonIsEnabled: (state) => {
        return state.vmBitsConnectionButtonIsEnabled;
    },

    get_twitchClientId: (state) => {
        return state.twitchClientId;
    },

    get_twitchAuthToken: (state) => {
        return state.twitchAuthToken;
    },

    get_twitchChannelId: (state) => {
        return state.twitchChannelId;
    },   

    get_isTwitchLinked: (state) => {
        return state.isTwitchLinked;
    },
};
